import { Ctas, type SectionOf } from './shared'

export default function ProseSection({ section }: { section: SectionOf<'prose'> }) {
  const centred = section.align === 'center'
  const large = section.size === 'lg'
  return (
    <div className={centred ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'}>
      {section.heading && (
        <h2
          className={
            large
              ? 'text-4xl font-bold tracking-tight sm:text-5xl'
              : 'text-3xl font-bold tracking-tight sm:text-4xl'
          }
        >
          {section.heading}
        </h2>
      )}
      {section.sub && (
        <p className={large ? 'mt-5 text-xl text-muted-foreground' : 'mt-4 text-lg text-muted-foreground'}>
          {section.sub}
        </p>
      )}
      {section.paragraphs?.map((p) => (
        <p
          key={p.slice(0, 40)}
          className={large ? 'mt-6 text-xl leading-relaxed' : 'mt-6 text-lg leading-relaxed'}
        >
          {p}
        </p>
      ))}
      {section.pullquote && (
        <p className="mt-10 text-xl font-medium leading-relaxed">
          {section.pullquote}
        </p>
      )}
      {section.cta &&
        (centred ? (
          <div className="flex justify-center">
            <Ctas items={[section.cta]} />
          </div>
        ) : (
          <Ctas items={[section.cta]} />
        ))}
    </div>
  )
}
